var map = {
	"./001bakery1.jpg": 721,
	"./001bakery3.jpg": 3362,
	"./001bakery4.jpg": 1458,
	"./001bakery5.jpg": 9420,
	"./001bakery6.jpg": 6006,
	"./001bakery7.jpg": 3444,
	"./002kidwash.jpg": 9475,
	"./10415629_900510303297611_832327333433026334_n[1].jpg": 7162,
	"./10497232_932978540050787_6667250648381282120_o[1].jpg": 3876,
	"./10544410_1041183635896943_8998580850659276422_n[1].jpg": 2875,
	"./10580794_932978686717439_1290890525613364884_o.jpg": 4431,
	"./10689864_987027034645937_4921907518837539121_n[1]-min.jpg": 6467,
	"./11845142_1159009257447713_5138441005650124255_o[1]-min.jpg": 3026,
	"./12342706_1227351627280142_6167626562170535691_n[1].jpg": 2340,
	"./12376236_1227351603946811_5500118720016644032_n[1]-min.jpg": 3558,
	"./12495955_1254361394579165_23457967181314947_o[1].jpg": 9499,
	"./13235595_1348908635124440_539880373123426715_o.jpg": 9347,
	"./13416877_1357641190917851_3245552054303699169_o.jpg": 2745,
	"./2460.JPG": 6700,
	"./291.jpg": 8490,
	"./29351784_2097373866944576_6414991038743535068_o.jpg": 1025,
	"./458.JPG": 6208,
	"./569ab750-487c-457a-bcca-c446a457f2bc.jpg": 5236,
	"./653.JPG": 6682,
	"./Breezy Point solar light project.jpg": 9182,
	"./Guyana March 2013 238.JPG": 887,
	"./Guyana March 2013 242.JPG": 1900,
	"./Guyana March 2013 258.JPG": 5636,
	"./IMG_0028.JPG": 7202,
	"./IMG_0734.JPG": 8458,
	"./IMG_1179.JPG": 7890,
	"./IMG_2620.JPG": 3416,
	"./IMG_2628.JPG": 9432,
	"./IMG_2743.JPG": 6294,
	"./IMG_2788.JPG": 1402,
	"./IMG_3180.JPG": 8925,
	"./IMG_3181.JPG": 7650,
	"./IMG_8151.jpg": 8519,
	"./IMG_8153.jpg": 4456,
	"./IMG_8154.jpg": 7404,
	"./Lichfield outreach.jpg": 1178,
	"./Opening of Capoey Bakery 20.JPG.jpg": 3257,
	"./Opening of Capoey Bakery 25.JPG.jpg": 59,
	"./Opening of Capoey Bakery 26.JPG.jpg": 7219,
	"./Opening of Capoey Bakery 56.JPG.jpg": 3428,
	"./Opening of Capoey Bakery 65.JPG.jpg": 8547,
	"./SAM_1453.JPG": 679,
	"./SAM_1512.JPG": 6545,
	"./SAM_1514.JPG": 728,
	"./Sunrise Bakery, Capoey 2.jpg": 9410,
	"./d6e2a762-23a2-4f64-9e5f-a00fa8da4826.jpg": 8743,
	"./pic11.JPG": 418,
	"./pic16.JPG": 8795,
	"./pic5.JPG": 8741,
	"./pic8.JPG": 5800,
	"./vr2.jpg": 9287,
	"./vr3.jpg": 8141,
	"./vr4.jpg": 7129,
	"./z.jpg": 699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9491;